import { render, staticRenderFns } from "./payOption.vue?vue&type=template&id=02116321&scoped=true&"
import script from "./payOption.vue?vue&type=script&lang=js&"
export * from "./payOption.vue?vue&type=script&lang=js&"
import style0 from "./payOption.vue?vue&type=style&index=0&id=02116321&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02116321",
  null
  
)

component.options.__file = "payOption.vue"
export default component.exports